import { Pipe, PipeTransform } from '@angular/core';
import { FrontEndColumn } from '../interfaces/front-end-column';

@Pipe({
  name: 'columnWidth',
})
export class ColumnWidthPipe implements PipeTransform {
  transform(value: FrontEndColumn): string {
    if (value.name == 'sku') {
      return '150px';
    } else if (value.name == 'name') {
      return '250px';
    }
    else {
      return '100px';
    }
  }
}
